"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdobeResponseFormat = void 0;
var AdobeResponseFormat;
(function (AdobeResponseFormat) {
    AdobeResponseFormat["JSON"] = "json";
})(AdobeResponseFormat = exports.AdobeResponseFormat || (exports.AdobeResponseFormat = {}));
